const EmptyState = ({
  icon = null,
  title =
    "Nothing here yet",
  message,
  action = null,
}) => {
  return (
    <div className="app-empty-state">
      {icon && (
        <div className="app-empty-state-icon">
          {icon}
        </div>
      )}

      <h3>
        {title}
      </h3>

      {message && (
        <p>
          {message}
        </p>
      )}

      {action && (
        <div className="app-empty-state-action">
          {action}
        </div>
      )}
    </div>
  );
};

export default EmptyState;